import React, { createContext, useContext } from "react";

type HeaderContextType = {
  header: React.ReactNode | null;
  secondHeader: React.ReactNode | null;
  updateHeader: (header: React.ReactNode | null) => void;
  updateSecondHeader: (header: React.ReactNode | null) => void;
};

const PageHeaderContext = createContext<HeaderContextType>({
  header: null,
  updateHeader: (newHeader: React.ReactNode | null) => {},
  secondHeader: null,
  updateSecondHeader: (newHeader: React.ReactNode | null) => {},
});

function PageHeaderProvider(props: { children: React.ReactNode }) {
  const [header, updateHeader] = React.useState<React.ReactNode>(<></>);
  const [secondHeader, updateSecondHeader] = React.useState<React.ReactNode>(
    <></>,
  );

  return (
    <PageHeaderContext.Provider
      value={{ header, updateHeader, secondHeader, updateSecondHeader }}
    >
      {props.children}
    </PageHeaderContext.Provider>
  );
}
const useHeader = () => useContext(PageHeaderContext);
export { PageHeaderProvider, useHeader };
